// Add "snap" class to body when scrolling past hero block on project pages
export function initProjectSnap() {
  // Only run on project pages
  if (!document.body.classList.contains('project')) {
    return;
  }

  const heroBlock = document.querySelector('.hero-block');

  if (!heroBlock) {
    return;
  }

  function checkScroll() {
    const heroBottom = heroBlock.offsetTop + heroBlock.offsetHeight - 1;
    const scrollPosition = window.scrollY;

    if (scrollPosition > heroBottom) {
      document.body.classList.add('snap');
    } else {
      document.body.classList.remove('snap');
    }
  }

  // Check on scroll
  window.addEventListener('scroll', checkScroll);

  // Check on page load
  checkScroll();
}
